import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { inject, NgModule, Pipe, PipeTransform } from '@angular/core';

import { Column } from '../../../interfaces';
import { ColumnValuePipe } from '../column-value/column-value.pipe';

@Pipe({
  name: 'columnFormattedValue',
})
export class ColumnFormattedValuePipe implements PipeTransform {
  private _columnValuePipe = inject(ColumnValuePipe);
  private _currencyPipe = inject(CurrencyPipe);
  private _datePipe = inject(DatePipe);
  private _decimalPipe = inject(DecimalPipe);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(row: any, column: Column, currency?: string, inputValueType = false): string {
    if (!column || row == null) {
      return '';
    }

    let value = this._columnValuePipe.transform(row, column);
    const type = column?.type === 'INPUT' && inputValueType ? column?.inputValueType || column.type : column.type;

    // exibe 0 quando configurado e o valor não for informado
    if (column?.showZero && (value === null || value === undefined || value === '')) {
      value = 0;
    }

    switch (type) {
      case 'DATE':
        return this._datePipe.transform(value, 'dd/MM/yy', column?.timezone) || '';
      case 'DATE4':
        return this._datePipe.transform(value, 'dd/MM/yyyy') || '';
      case 'DATETIME':
        return this._datePipe.transform(value, 'dd/MM/yy HH:mm') || '';
      case 'DAYMONTHTIME':
        return this._datePipe.transform(value, 'dd/MM HH:mm') || '';
      case 'TIME':
        return this._datePipe.transform(value, 'HH:mm:ss') || '';
      case 'TIMESTAMP':
        return this._datePipe.transform(value, 'dd/MM/yy HH:mm:ss') || '';
      case 'CURRENCY':
        return this._currencyPipe.transform(value, currency, 'symbol', '1.2-2') || '';
      case 'FLOAT2':
        return this._decimalPipe.transform(value, '1.2-2') || '';
      case 'FLOAT4':
        return this._decimalPipe.transform(value, '1.2-4') || '';
      default:
        return value;
    }
  }
}

@NgModule({
  imports: [CommonModule],
  providers: [ColumnValuePipe, CurrencyPipe, DatePipe, DecimalPipe],
})
export class ColumnFormattedValuePipeModule {}
